export default __webpack_public_path__ + "static/media/Support_Normal.cbf2c4ec.svg";